import { useCallback } from "react";

import type { ReservationDetailUpdateIssuedReceiptStatusInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailUpdateIssuedReceiptStatus = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationDetailUpdateIssuedReceiptStatus: _onUpdateReservationDetailUpdateIssuedReceiptStatus } =
		MutationRepository.useReservationDetailUpdateIssuedReceiptStatusUpdateMutation();

	/**
	 * 予約詳細の領収書のステータスの更新を実行
	 */
	const onUpdateReservationDetailUpdateIssuedReceiptStatus = useCallback(
		(statusReceiptIssued: ReservationDetailUpdateIssuedReceiptStatusInput["statusReceiptIssued"]) => {
			const input: ReservationDetailUpdateIssuedReceiptStatusInput = {
				statusReceiptIssued,
				hotelID,
				reservationID,
			} satisfies ReservationDetailUpdateIssuedReceiptStatusInput;
			_onUpdateReservationDetailUpdateIssuedReceiptStatus(input);
		},
		[_onUpdateReservationDetailUpdateIssuedReceiptStatus, hotelID, reservationID],
	);

	return {
		onUpdateReservationDetailUpdateIssuedReceiptStatus,
	};
};
